// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__8WMhP","loader-container":"button_loader-container__KXSRU","secondary":"button_secondary__Mn__I","outline":"button_outline__l2Brq"};